import { useMemo } from 'react';

import useMindStorage, { EStorageKey } from './useMindStorage';

/**
 * Custom hook to get avatar map from session members
 * This provides O(1) lookup performance instead of O(N) with find()
 * The map is memoized and shared across components using the same session
 */
export function useSessionAvatarMap(): Map<string, string> {
  const [sessionInfo] = useMindStorage(EStorageKey.SESSION_INFO);

  const avatarMap = useMemo(() => {
    if (!sessionInfo?.members) return new Map<string, string>();

    return new Map(sessionInfo.members.map((member) => [member.userId, member.avatar]));
  }, [sessionInfo?.members]);

  return avatarMap;
}

/**
 * Custom hook to get member info map from session members
 * This provides O(1) lookup performance for full member info
 */
export function useSessionMemberMap() {
  const [sessionInfo] = useMindStorage(EStorageKey.SESSION_INFO);

  const memberMap = useMemo(() => {
    if (!sessionInfo?.members) return new Map();

    return new Map(sessionInfo.members.map((member) => [member.userId, member]));
  }, [sessionInfo?.members]);

  return memberMap;
}
